import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OCRScannedDocContainerModel } from "../../../../../models";
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';

// https://api.akaun.dev/core2/platform/dm/tenants/tenant-users

@Injectable({
  providedIn: 'root'
})

export class OCRScannedDocService extends BaseApiPublicLoginTemplateService<OCRScannedDocContainerModel,OCRScannedDocContainerModel, OCRScannedDocContainerModel> {

  static readonly OCR_SCANNED_DOCS_SUB_PATH = 'ocr/scanned-docs/';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + OCRScannedDocService.OCR_SCANNED_DOCS_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + OCRScannedDocService.OCR_SCANNED_DOCS_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + OCRScannedDocService.OCR_SCANNED_DOCS_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    // TODO: Change to respected ep-types once they are complete
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + OCRScannedDocService.OCR_SCANNED_DOCS_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + OCRScannedDocService.OCR_SCANNED_DOCS_SUB_PATH + BaseApiTemplateService.LOGIN_ENTITY_EP;
  }
}

